module.exports = function (btsUi) {
    btsUi.service('healthToolsService', ['services', 'session','displayOrHideItemsWrapper', function (services, session, displayOrHideItemsWrapper) {

        var model = {};
        var brand = "";
        var isASubscriber = "";

        //call this function before calling other functions.this populates the basic data needed in model variable
        this.populateModel = function () {
            if (session && session.data && session.data.loggedIn) {
                var memberInfo = session.data.memberInfo;
                processMemberInfo(memberInfo, model);
                if (!memberInfo) {
                    services.rbsmbl.memberInfo().fetch().then(function (response) {
                        processMemberInfo(memberInfo, model);
                    });
                }
            }
        };


        processMemberInfo = function (memberInfo, model) {
            model.memberInfo = memberInfo;
            model.currentMember = services.rbsmbl.memberInfo().currentMember(memberInfo);
            model.selectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(memberInfo);
            model.selectedClient = services.rbsmbl.memberInfo().getPortalSelectedClient(memberInfo,model.selectedPlan.groupNumber);
            model.uniqueProducts = services.rbsmbl.memberInfo().getUniqueProducts(memberInfo);
            model.activeProducts = currentActiveProducts(model.uniqueProducts,model.selectedPlan.groupNumber);
            model.activeMedicalProduct = getActiveProductByPlanType(model.activeProducts, 'medical');
            brand = memberInfo.brand;
        };
        this.isASubscriber = function () {
            return model.selectedPlan && model.selectedPlan.productList && model.selectedPlan.productList[0].memberList[0].relationship == "Subscriber";
        };
        this.isQualifiedSenior = function () {
            return model.selectedPlan && model.selectedPlan.productList && model.selectedPlan.productList[0].seniorProductIndicator && model.selectedPlan.productList[0].seniorProductIndicator === "true";
        };
        this.isDirectPay = function () {
            return model.selectedPlan && model.selectedPlan.directPayIndicator &&  model.selectedPlan.directPayIndicator === "true";
        };
        this.getPayPlanPremium = function () {
            var payPremiumData = {};
            if (model.selectedPlan && model.selectedPlan.productList && model.selectedPlan.productList.length>0 && model.selectedPlan.productList[0]) {
                payPremiumData.showPayPlanPremium = (this.isQualifiedSenior() || this.isDirectPay() && this.isASubscriber());
            }
            return payPremiumData;
        };

        this.curMedicareGrpProd = function(){
            var currMedicareMedRXProd =[];
            for (var i = 0; i < model.selectedPlan.productList.length; i++) {
                if (model.selectedPlan.productList[i].mnMedicareProductIndicator) {
                    if(model.selectedPlan.productList[i].benefitPlanType === "Medical" && model.selectedPlan.productList[i].drugCoverage == 'true'
                        && !model.selectedPlan.productList[i].isMedicarePartB ){
                        currMedicareMedRXProd = model.selectedPlan.productList;
                    }
                }
            }

            return currMedicareMedRXProd;
        };


        this.getCCEData = function () {
            var cceData = {};
            //show CCE indicator
            //TODO :verify team site appconfig keys to show/suppress links
            if (model.activeMedicalProduct && model.activeMedicalProduct.benefitPlanType == 'Medical') {
                cceData.showCCELink = model.selectedPlan.hasCareCostEstimator && model.selectedPlan.hasCareCostEstimator === "true";
                var effectiveDate = model.activeMedicalProduct.memberList[0].coverageEffectiveDate;
                cceData.effDate = effectiveDate && effectiveDate.replace(/\//gi, '');
                cceData.groupNumber = model.selectedPlan.groupNumber;
                cceData.clientNumber = model.selectedClient.clientNumber;
            } else {
                cceData.showCCELink = false;
            }
            return cceData;
        };

        this.getTelemedicineVendorName = function () {
            var teleMedicineVendors = getTeleMedicineVendors(model.activeProducts);
            if (teleMedicineVendors && teleMedicineVendors.length > 0) {
                return ((teleMedicineVendors[0] && teleMedicineVendors[0].toUpperCase() === 'YES') ? teleMedicineVendorName = "ONLINECAREANYWHERE" : "DEFAULT");
            }
            return "";
        };

        this.showTeleMedicine = function (supressOnlineGroups) {
            var teleMedicineData = {};
            if (model.selectedPlan && model.selectedPlan.groupNumber && supressOnlineGroups && supressOnlineGroups.trim().length > 0) {
                var arrGrps = supressOnlineGroups.replace(/\s/g, '').split(",");
                return (arrGrps.indexOf(model.selectedPlan.groupNumber) == -1);
            } else {
                return true;
            }
        };
        var getPharmaBenefitProvider =function(){
            if(model.selectedPlan && model.selectedPlan.pharmacyBenefitProviderIndicator
                && model.selectedPlan.pharmacyBenefitProviderIndicator.toUpperCase()!='NONE'){
                return model.selectedPlan.pharmacyBenefitProviderIndicator.toUpperCase();
            }
            return "";
        }
        var validatePharmacyBenefitProvider =function(pharmacyBenefitProvider,pharmacyProviders){
            return pharmacyBenefitProvider && pharmacyProviders && pharmacyProviders.toString().toUpperCase().indexOf(pharmacyBenefitProvider.trim()) > -1;
        }
        var getPrescription =function(pharmacyBenefitProvider,pharmacyProviders){
            return pharmacyBenefitProvider && pharmacyProviders && pharmacyProviders.toString().toUpperCase().indexOf(pharmacyBenefitProvider) > -1;
        }
        var getPrescriptionUrlObj = function(pharmacyBenefitProvider,pharmacyProvidersURls){
            var vendorObj={};
            if (pharmacyBenefitProvider && pharmacyProvidersURls) {
                pharmacyBenefitProvider = pharmacyBenefitProvider.trim();
                vendorObj = pharmacyProvidersURls[pharmacyBenefitProvider] ? pharmacyProvidersURls[pharmacyBenefitProvider] : pharmacyProvidersURls['DEFAULT'];
            }
            return vendorObj;
        }

        this.showPrescriptionServices = function (prescriptionJsonInfo) {
            // var prescriptionServices = {};
            var showPrescriptionService = false;
            var currentMedicalProduct = model.activeMedicalProduct;
            var pharmacyBenefitProvider;
            var vendorObj={};
            var hasRequiredLob;
            var currentRxProductList = getActiveProductByPlanType(model.activeProducts, 'Drug');
            if (currentMedicalProduct) {
                pharmacyBenefitProvider = getPharmaBenefitProvider();
                showPrescriptionService=validatePharmacyBenefitProvider(pharmacyBenefitProvider,prescriptionJsonInfo.arrPharmacyProviders);
                if (showPrescriptionService) {
                    vendorObj= getPrescriptionUrlObj(pharmacyBenefitProvider,prescriptionJsonInfo.arrPharmacyProviderUrls);
                } else {
                    var hasRxClaims = (currentMedicalProduct.rxClaims == 'true');
                    if (!hasRxClaims) {
                        var medicalPlanDrugCoverage = currentMedicalProduct.drugCoverage && currentMedicalProduct.drugCoverage == 'true';
                        var integratedCovIndicator = currentMedicalProduct.integratedCoverageIndicator && currentMedicalProduct.integratedCoverageIndicator == 'true';
                        var hasIntegratedDrugCoverage = medicalPlanDrugCoverage && integratedCovIndicator ;
                        var theLob = currentMedicalProduct.lob? currentMedicalProduct.lob:"";
                        var arrPossibleLobValues = ['HMO', 'PPO', 'EPO', 'HDHP', 'CV', 'POS', 'TDL'];
                        hasRequiredLob = arrPossibleLobValues.indexOf(theLob.toUpperCase()) > -1;
                        if (hasRequiredLob && hasIntegratedDrugCoverage) {
                            showPrescriptionService = true;
                            vendorObj = (prescriptionJsonInfo && prescriptionJsonInfo.arrPharmacyProviderUrls['HEALTHTOOLS_RX_LINK']) ? prescriptionJsonInfo.arrPharmacyProviderUrls['HEALTHTOOLS_RX_LINK'] : "";
                        } else {
                            showPrescriptionService = false;
                        }
                    } else {
                        // rxClaims is true (and other conditions are not true) so we do not show the item
                        showPrescriptionService = false;
                    }
                }
            }
            // Show prescription service link for Standalone Rx users.

            if (currentRxProductList) {
                var currentRxProduct =currentRxProductList;
                var rxPlanDrugCoverage = (currentRxProduct.drugCoverage == 'true');
                hasRequiredLob = currentRxProduct.lob && currentRxProduct.lob.toUpperCase() == 'PDG' ;
                pharmacyBenefitProvider = getPharmaBenefitProvider();
                showPrescriptionService=validatePharmacyBenefitProvider(pharmacyBenefitProvider,prescriptionJsonInfo.drugCoverageProviders);

                if (showPrescriptionService) {
                    vendorObj = getPrescriptionUrlObj(pharmacyBenefitProvider,prescriptionJsonInfo.drugCoverageProviderUrls);
                } // end if PharmacyBenefitProvider
                else {
                    if (rxPlanDrugCoverage && hasRequiredLob) {
                        showPrescriptionService = true;
                        vendorObj = (prescriptionJsonInfo && prescriptionJsonInfo.drugCoverageProviderUrls['HEALTHTOOLS_RX_LINK']) ? prescriptionJsonInfo.drugCoverageProviderUrls['HEALTHTOOLS_RX_LINK'] : ""
                    }
                    else {
                        showPrescriptionService = false;
                    }
                } // else PharmacyBenefitProvider
            } // end Rx Product
            if (!showPrescriptionService) {
                var cancelledMedicalProduct = this.getCanceledProducts('Drug');
                if (cancelledMedicalProduct) {
                    showPrescriptionService = true;
                }
            }
            // prescriptionServices.showPrescriptionService = showPrescriptionService;
            if (vendorObj) {
                vendorObj.showPrescriptionService = showPrescriptionService;
            }
            return vendorObj;
        };

        this.getRXCarveOutVendor =function(){
            var clientNumber =model.selectedClient?model.selectedClient.clientNumber:"";
            var groupNumber = model.selectedPlan ?model.selectedPlan.groupNumber:"";
            if(clientNumber && groupNumber ){
                return displayOrHideItemsWrapper.displayOrHideItemsCall(clientNumber, model.selectedPlan.groupNumber, ['rxCarveOutVendor'], brand);
            }
            return "";

        }

        this.getCanceledProducts = function (planType) {
            var cancelledPlans = [];
            var theProduct = null;
            if (model.selectedPlan &&
                model.selectedPlan.productList &&
                model.selectedPlan.productList.length > 0) {
                var products = model.selectedPlan.productList;
                // get the current plans
                var coverageIsCancelled = false;
                products.forEach(function (product) {
                    var millisBeginDate = product.memberList[0].coverageEffectiveDate?Date.parse(product.memberList[0].coverageEffectiveDate):"";
                    var millisEndDate = product.memberList[0].coverageCancellationDate?Date.parse(product.memberList[0].coverageCancellationDate):"";
                    if(millisBeginDate && millisEndDate){
                        //converts milliseconds to days
                        var beginDays = Math.floor(millisBeginDate / 86400000);
                        var endDays = Math.floor(millisEndDate / 86400000);
                        coverageIsCancelled = ( endDays - beginDays <= 90) ? true : false;
                        if (coverageIsCancelled) {
                            cancelledPlans.push(product);
                        }
                        coverageIsCancelled = false;
                    }

                });

            }
            cancelledPlans.forEach(function (plan) {
                theProduct = (plan.benefitPlanType.trim().toLowerCase() == planType.trim().toLowerCase()) ? plan : theProduct;
            });

            return theProduct;
        };


        this.showRetailCenter = function () {
            return true;
        };

        this.showFindDoctor = function () {
            return true;
        };
        this.showCHC = function () {
            var showCHC = (model.selectedPlan && model.selectedPlan.chcIndicator && model.selectedPlan.chcIndicator == 'true');
            return showCHC;
        };

        var currentActiveProducts = function (productList,groupNumber) {
            if (productList) {
                var prods = productList;
                var activeProducts = [];
                var milliServerDate = Date.parse(new Date()); // use serverDate( ) when that is ready in bts
                for (var i = 0; i < prods.length; i++) {
                    if(prods[i].groupData.groupNumber && prods[i].groupData.groupNumber===groupNumber){
                        var millisBeginDate = Date.parse(prods[i].productData.coverageConBeginDate);
                        var millisEndDate = Date.parse(prods[i].productData.coverageEndDate);
                        var coverageIsCurrent = false;
                        coverageIsCurrent = ((millisBeginDate < milliServerDate) && (milliServerDate < millisEndDate));
                        if (coverageIsCurrent) {
                            activeProducts.push(prods[i].productData);
                        }
                    }
                }
                return activeProducts;
            } else {
                return null;
            }
        };


        var getTeleMedicineVendors = function (products) {
            var teleMedicineVendors = [];
            if (products) {
                for (var i = 0; i < products.length; i++) {
                    var product = products[i];
                    if (product.telemedicineVendorName && product.telemedicineVendorName.trim().length > 0) {
                        if ((teleMedicineVendors.toString()).indexOf("Teladoc") == -1) {
                            // we dont want duplicates
                            teleMedicineVendors.push(product.telemedicineVendorName);
                        }
                    }
                }
            }
            return teleMedicineVendors;
        };

        var getActiveProductByPlanType = function (activeProducts, planType) {
            if (activeProducts && planType) {
                for (var i = 0; i < activeProducts.length; i++) {
                    var product = activeProducts[i];
                    if (product.benefitPlanType && (product.benefitPlanType.trim().toLowerCase() == planType.trim().toLowerCase())) {
                        return product;
                    }
                }
            }
            return null;
        };

        var getGuideWellIndicator = function (activeProducts) {
            if (activeProducts) {
                for (var i = 0; i < activeProducts.length; i++) {
                    var product = activeProducts[i];
                    if (product.mnMedicareProductIndicator && product.mnMedicareProductIndicator===true) {
                        return true;
                    }
                }
            }
            return false;
        };

        this.showGuideWell=function(){
            return getGuideWellIndicator(model.activeProducts);
        };
        this.checkIfEbillUserExists = function () {
            return services.rbsmbl.ebillUserExists().getTargetUrl(session.data.memberInfo.brand);
        };
        //check if tool to be supressed or allowed at Client or Group Level
        this.initialCheck = function (supressGroups, supressClients,eligibleGroups,eligibleClients) {
            var clientNumber = model.selectedClient?model.selectedClient.clientNumber:"";
            var groupNumber = model.selectedPlan?model.selectedPlan.groupNumber:"";
            if(groupNumber && eligibleGroups && eligibleGroups.length>0 ){
                if(eligibleGroups.indexOf(groupNumber)>-1){
                    return false;
                }else{
                    return true;
                }
            } else if(clientNumber && eligibleClients &&  eligibleClients.length>0){
                if(eligibleClients.indexOf(clientNumber)>-1){
                    return false;
                }else{
                    return true;
                }
            }
            else {
                if (clientNumber && supressClients && supressClients.length > 0) {
                    if (supressClients.indexOf(clientNumber) > -1) {
                        return true;
                    }
                }
                if (groupNumber && supressGroups && supressGroups.length > 0) {
                    if (supressGroups.indexOf(groupNumber) > -1) {
                        return true;
                    }
                }
            }

            return false;
        };
        this.getModel = function () {
            return model;
        };
    }]);
};

